/*
*   Carousel Functionality
*   Shared carousel initialization and configuration across all themes and projects
*/

// Initialize Slick carousels with default settings
function initializeCarousels() {
    // Detect RTL once — Slick's `rtl: true` option flips slide order, dot order,
    // arrow positions and animation direction so RTL users get the correct feel
    // (left arrow = forward, right arrow = back).
    var isRtl = $('html').attr('dir') === 'rtl';

    // Hero carousel
    $('.hero-carousel').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        adaptiveHeight: true,
        rtl: isRtl
    });

    // Content carousel
    $('.content-carousel').slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        rtl: isRtl,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    // Testimonial carousel
    $('.testimonial-carousel').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: true,
        fade: true,
        rtl: isRtl
    });
}

// Export for use in other modules
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { initializeCarousels };
}